module.exports = __webpack_public_path__ + "img/bg-sou-lojista.1785e7eb.jpg";